import { StorageValues } from "../constants/storageValues";
import { Stringutility } from "../utilities/stringutility";
import { StorageService } from "./StorageService";

export const APIResposneService = {
  saveAuthToken,
  saveLoginAuthResponse,
  saveFireBaseAuthResponse,
  isProfileCompleted,
  getBasicInfoResponse,
  getReviewerRatingDetails
};

function saveAuthToken(authToken) {
  StorageService.saveInLocalStorage(StorageValues.AUTH_TOKEN, authToken);
}

function saveLoginAuthResponse(response) {
  var userId = Stringutility.getValue(response.id);
  var email = Stringutility.getValue(response.email);
  var firstName = Stringutility.getValue(response.firstName);
  var lastName = Stringutility.getValue(response.lastName);
  var contactNumber = Stringutility.getValue(response.contactNumber);

  StorageService.saveInLocalStorage(StorageValues.USER, userId);
  StorageService.saveInLocalStorage(StorageValues.EMAIL, email);
  StorageService.saveInLocalStorage(StorageValues.NAME, firstName);
  StorageService.saveInLocalStorage(StorageValues.LASTNAME, lastName);
  StorageService.saveInLocalStorage(
    StorageValues.CONTACT_NUMBER,
    contactNumber
  );
}

function saveFireBaseAuthResponse(response) {
  var email = Stringutility.getValue(response.email);
  if (response.displayName !== null) {
    const fullName = response.displayName.split(" ");
    const firstName = Stringutility.getValue(fullName[0]);
    const lastName = Stringutility.getValue(fullName[1]);

    StorageService.saveInLocalStorage(StorageValues.NAME, firstName);
    StorageService.saveInLocalStorage(StorageValues.LASTNAME, lastName);
  }

  var contactNumber = Stringutility.getValue(response.phoneNumber);
  StorageService.saveInLocalStorage(StorageValues.EMAIL, email);
  StorageService.saveInLocalStorage(
    StorageValues.CONTACT_NUMBER,
    contactNumber
  );
}

function isProfileCompleted(response) {
  var isCompleted = false;
  try {
    if (response.data != null) {
      const candidateReviewDetails = response.data;
      if (candidateReviewDetails != null) {
        const jobPref = candidateReviewDetails.jobPref;
        if (jobPref !== null) {
          const prefAddress = jobPref.address;
          if (prefAddress !== null) {
            isCompleted = true;
          } else {
            isCompleted = false;
          }
        } else {
          isCompleted = false;
        }
      } else {
        isCompleted = false;
      }
    } else {
      isCompleted = false;
    }
  } catch (err) {
    isCompleted = false;
  }  
  return isCompleted;
}

function getBasicInfoResponse(response){
   let workAuthorization= Stringutility.getValue(response.workAuthorization);
   let firstName=Stringutility.getValue(response.firstName);
   let middleName=Stringutility.getValue(response.middleName);
   let lastName=Stringutility.getValue(response.lastName);
   let namePreference=Stringutility.getValue(response.namePreference);
   let birthMonth=Stringutility.getValue(response.birthMonth);
   let birthDay=Stringutility.getValue(response.birthDay);
   let email=Stringutility.getValue(response.email);
   let contactNumber=Stringutility.getValue(response.contactNumber);
   let secondaryNumber=Stringutility.getValue(response.secondaryNumber);
   let prefContactTime=Stringutility.getValue(response.prefContactTime);
   let prefContactMethod=Stringutility.getValue(response.prefContactMethod);
   let internalNote=Stringutility.getValue(response.internalNote);
   let adlPublicInfo=Stringutility.getValue(response.adlPublicInfo);

   if(Stringutility.isNullOrEmpty(firstName)){
    firstName=Stringutility.getValue(StorageService.getFromLocalStorage(StorageValues.NAME));
   }

   if(Stringutility.isNullOrEmpty(lastName)){
    lastName=Stringutility.getValue(StorageService.getFromLocalStorage(StorageValues.LASTNAME));
   }

   if(Stringutility.isNullOrEmpty(email)){
    email=Stringutility.getValue(StorageService.getFromLocalStorage(StorageValues.EMAIL));
   }

   if(Stringutility.isNullOrEmpty(contactNumber)){
    contactNumber=Stringutility.getValue(StorageService.getFromLocalStorage(StorageValues.CONTACT_NUMBER));
   }

   return {
    workAuthorization: workAuthorization,
    firstName:firstName,
    lastName:lastName,
    middleName: middleName,
    namePreference:namePreference,
    birthMonth:birthMonth,
    birthDay:birthDay,
    email:email,
    contactNumber: contactNumber,
    secondaryNumber: secondaryNumber,
    prefContactTime:prefContactTime,
    prefContactMethod:prefContactMethod,
    internalNote:internalNote,
    adlPublicInfo:adlPublicInfo
   } 
}

function getReviewerRatingDetails(response){
  let firstName= Stringutility.getValue(response.firstName);
  let lastName=Stringutility.getValue(response.lastName);
  let email= Stringutility.getValue(response.email);
  let contactNumber=Stringutility.getValue(response.contactNumber);

  StorageService.saveInSessionStorage(StorageValues.REVIEWER_NAME, firstName);
  StorageService.saveInSessionStorage(StorageValues.REVIEWER_LAST_NAME, lastName);
  StorageService.saveInSessionStorage(StorageValues.REVIEWER_EMAIL, email);
  StorageService.saveInSessionStorage(StorageValues.REVIEWER_CONTACT_NUMBER, contactNumber);

  const reviewResponse={
    firstName: firstName,
    lastName:lastName,
    email:email,
    contactNumber:contactNumber
  }

  return reviewResponse;
}

